import { useLocalSearchParams } from 'expo-router';
import { StyleSheet, View } from 'react-native';

import { useGetUserImpact } from '@/api/hooks/donationHooks';
import DotsLoader from '@/components/DotsLoader';
import ImpactList from '@/components/impact/ImpactList';
import TotalImpact from '@/components/impact/TotalImpact';

const YearImpact = () => {
  const { npoType } = useLocalSearchParams<{ npoType: 'charity' | 'church' }>();
  const { data, isPending } = useGetUserImpact({ npoType: npoType, periodTime: 'year' });

  if (isPending) {
    return (
      <View style={styles.loadingContainer}>
        <DotsLoader />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <TotalImpact amount={data?.totalAmount ?? 0} />
      <ImpactList npoType={npoType} periodTime={'year'} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },

  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  }
});

export default YearImpact;
